import { render } from "./Lotes_cat.vue?vue&type=template&id=48c5132f&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./Lotes_cat.vue?vue&type=script&lang=js"
export * from "./Lotes_cat.vue?vue&type=script&lang=js"
script.render = render

export default script